<card-analytics [titleText]="'crmContacts.revenueAnalysis.title' | translate" contentClass="sales-by-state grid">
  <dx-data-grid
    [dataSource]="data"
    [height]="290"
    [loadPanel]="{ enabled: false }"
  >
    <dxi-data-grid-column [caption]="'crmContacts.revenueAnalysis.state' | translate" dataField="stateName"> </dxi-data-grid-column>

    <dxi-data-grid-column
      alignment="left"
      [caption]="'crmContacts.revenueAnalysis.sales' | translate"
      dataField="total"
      dataType="number"
      format="currency"
      sortOrder="desc"
      [hidingPriority]="2"
    >
    </dxi-data-grid-column>

    <dxi-data-grid-column
      alignment="left"
      [caption]="'crmContacts.revenueAnalysis.percentSold' | translate"
      dataField="percentage"
      name="percentN"
      format="percent"
      [hidingPriority]="1"
    >
    </dxi-data-grid-column>

    <dxi-data-grid-column
      alignment="left"
      [caption]="'crmContacts.revenueAnalysis.percentage' | translate"
      dataField="percentage"
      name="percentB"
      cellTemplate="salesBullet"
      cssClass="sales-bullet"
      [width]="200"
    >
    </dxi-data-grid-column>

    <div *dxTemplate="let cellInfo of 'salesBullet'">
      <dx-bullet
        [showTarget]="false"
        [showZeroLevel]="false"
        [value]="cellInfo.data.percentage * 100"
        [startScaleValue]="0"
        [endScaleValue]="100"
      >
        <dxo-tooltip [enabled]="false"></dxo-tooltip>
        <dxo-size [width]="200" [height]="20"></dxo-size>
      </dx-bullet>
    </div>
  </dx-data-grid>
</card-analytics>
